import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-491a9226"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blog-header blog-container w-100" }
const _hoisted_2 = { class: "profile d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-avatar" }, null, -1))
const _hoisted_4 = { class: "profile-links d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "site-btn" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "www.erictarter.com" })
], -1))
const _hoisted_6 = { class: "blog-info d-flex flex-column align-items-start mt-5" }
const _hoisted_7 = { class: "blog-title" }
const _hoisted_8 = { class: "date-written mb-1 mt-2" }
const _hoisted_9 = { class: "read-time" }

import Socials from './utilities/Socials.vue'
  import Divider from './utilities/Divider.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BlogHeader',
  props: {
    title: {},
    date: {},
    readTime: {}
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Socials),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.date), 1),
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.readTime), 1)
    ]),
    _createVNode(Divider)
  ]))
}
}

})